import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import moment from 'moment';

import { SetNewValueObject } from '@vi-iot/client';
import { DataKeyValues, SemanticValues, TranslationIdValues } from '../../diagnostics-constants';

@Component({
  selector: 'app-vdd-date-edit',
  templateUrl: './vdd-date-edit.component.html',
  styleUrls: ['./vdd-date-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddDateEditComponent implements OnInit {
  @Input() matchedValues: any[];
  @Input() skipIndexes: number[];
  @Input() index: number;
  @Output() setNewValue = new EventEmitter<SetNewValueObject>();
  isFullDate = true;
  dayValue: any;
  monthValue: any;
  yearValue: any;
  skippedIndexes: number[] = [];
  datepickerDate: FormControl<Date>;
  firstValueType: TranslationIdValues;
  translationIdsToCheck = [
    TranslationIdValues.Day,
    TranslationIdValues.Month,
    TranslationIdValues.Year,
  ];

  constructor() {}

  ngOnInit(): void {
    this.firstValueType = this.matchedValues[this.index][DataKeyValues.TranslationId];
    this.skippedIndexes.push(this.index);
    this.getAllDateData();
    this.datepickerDate = new FormControl<Date | undefined>(undefined);
    if (this.dayValue && this.monthValue && this.yearValue) {
      const dateString = `${this.yearValue.value}-${this.monthValue.value}-${this.dayValue.value}`;
      const momentDate = moment(dateString, 'YY-MM-DD');
      this.datepickerDate.setValue(momentDate.toDate());
    } else {
      this.isFullDate = false;
    }
  }

  onDateChange(event: any): void {
    const newSelectedDate = moment(event.value);
    this.setNewValue.emit({
      path: this.yearValue.path,
      newValue: newSelectedDate.format('YY'),
    });
    this.setNewValue.emit({
      path: this.monthValue.path,
      newValue: newSelectedDate.format('M'),
    });
    this.setNewValue.emit({
      path: this.dayValue.path,
      newValue: newSelectedDate.format('D'),
    });
  }

  private getAllDateData(): void {
    for (let i = this.index; i < this.matchedValues.length; i++) {
      const value = this.matchedValues[i];

      if (i > this.index && this.firstValueType === value[DataKeyValues.TranslationId]) {
        break;
      }

      if (
        this.translationIdsToCheck.includes(value?.translationid) &&
        value?.semantic !== SemanticValues.DESCRIPTION
      ) {
        if (i > this.index) {
          this.skipIndexes.push(i);
          this.skippedIndexes.push(i);
        }
        switch (value?.[DataKeyValues.TranslationId]) {
          case TranslationIdValues.Day: {
            this.dayValue = this.matchedValues[i];
            break;
          }
          case TranslationIdValues.Month: {
            this.monthValue = this.matchedValues[i];
            break;
          }
          case TranslationIdValues.Year: {
            this.yearValue = this.matchedValues[i];
            break;
          }
        }
      } else {
        break;
      }
    }
  }
}
